import {observer} from "mobx-react";
import {ModalDialog, Page, PageContentTitle} from "../../ui";
import {
    DialogStore,
    growlStore,
    validationStore,
    vdaCustomerStore,
    vdaDetailStore,
    vdaPlacementStore
} from "../../../store";
import {VdaForm, VdaFormValidation} from "./VdaForm";
import {useState} from "react";
import {PageContentTitleAction} from "@kroschke/react-ui/dist/components/PageContentTitle";
import {convertStatus} from "../../../api";

const VdaDetailPage = observer(function VdaDetailPage() {
    const [cancelDialog] = useState(new DialogStore())
    const display = `${vdaDetailStore.vin || ''} (${convertStatus(vdaDetailStore.status)})`


    const validation: VdaFormValidation = {
        customer: validationStore.getFor('customer') || validationStore.getFor('customerId'),
        placement: validationStore.getFor('placementProcessId'),
        vin: validationStore.getFor('fin'),
        vinCheckDigit: validationStore.getFor('vinCheckDigit'),
        documents: validationStore.getFor('documents'),
        errorByDocument:validationStore.getErrorForDocuments()
    }

    const pageActions: PageContentTitleAction[] = []
    if (vdaDetailStore.editable && !vdaDetailStore.dirty && vdaDetailStore.valid) {
        pageActions.push({
            label: 'Erfassung abschließen',
            cls: `is-primary ${vdaDetailStore.saving ? 'is-loading' : ''}`,
            action: async () => {
                const id = await vdaDetailStore.transfer()
                if (!id) {
                    return
                }
                vdaDetailStore.reset()
                growlStore.add({
                    message: 'Die Erfassung wurde abgeschlossen',
                    autoclose: 1000,
                    closable: true
                })
            }
        })
    }

    if (vdaDetailStore.reopenable) {
        pageActions.push({
            label: 'Erfassung öffnen',
            cls: `is-primary ${vdaDetailStore.saving ? 'is-loading' : ''}`,
            action: async () => {
                const id = await vdaDetailStore.reopen()
                if (!id) {
                    return
                }

                growlStore.add({
                    message: 'Die Erfassung wurde nach Fehler wieder geöffnet',
                    autoclose: 1000,
                    closable: true
                })
            }
        })
    }

    pageActions.push({
        label: 'Speichern',
        cls: `is-primary ${vdaDetailStore.saving ? 'is-loading' : ''}`,
        disabled: !(vdaDetailStore.dirty && vdaDetailStore.valid),
        action: async () => {
            const id = await vdaDetailStore.save()
            if (!id) {
                return
            }
            vdaDetailStore.reset()
            growlStore.add({
                message: 'Die Erfassung wurde erfolgreich gespeichert',
                autoclose: 1000,
                closable: true
            })
        }
    })

    pageActions.push({
        label: 'Verwerfen',
        cls: 'is-primary is-outlined',
        disabled: vdaDetailStore.saving || !vdaDetailStore.dirty,
        action: async () => {
            cancelDialog.dialogOpen = true
        }
    })

    return <Page
        breadcrumb={[
            {
                link: '/vda',
                label: `Fahrzeugerfassung`
            },
            {
                link: `/vda/${vdaDetailStore.id}`,
                label: display
            }
        ]}
    >
        <ModalDialog
            store={cancelDialog}
            actions={[
                {
                    label: "Abbrechen",
                    execute: async function () {
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-primary is-rounded is-small'
                },
                {
                    label: "Verwerfen",
                    execute: async function () {
                        vdaDetailStore.reset()
                        cancelDialog.dialogOpen = false
                    },
                    className: 'is-rounded is-small'
                }
            ]}
            title={"Änderungen verwerfen?"}
        >
            Sind Sie sich sicher, dass Sie die Änderungen verwerfen wollen?
        </ModalDialog>
        <PageContentTitle actions={pageActions}>{display}</PageContentTitle>
        <VdaForm
            messages={vdaDetailStore.messages}
            disabled={!vdaDetailStore.editable}
            validation={validation}
            leadingLicensePlate={vdaDetailStore.leadingLicensePlate}
            customers={vdaCustomerStore.items}
            placements={vdaPlacementStore.items}
            value={vdaDetailStore.formData}
            onChange={data => vdaDetailStore.formData = data}
            onBlur={() => vdaDetailStore.validate()}
            onSearchCustomer={async (query) => await vdaCustomerStore.search(query)}
        />
    </Page>
})

export {
    VdaDetailPage
}
